const p = {
  class: {
    canCreateNew: true,
    canEditExisting: true,
  },
  topic: {
    notes: {
      canPublish: true,
      showDraft: true,
      reviewOptions: [
        {
          value: 'inactive',
          label: 'Inactive',
        },
        {
          value: 'review',
          label: 'Submit back to user',
        },
        {
          value: 'qc_review',
          label: 'Submit back to QC',
        },
      ],
    },
    geekCorner: {
      canPublish: true,
      showDraft: true,
      reviewOptions: [
        {
          value: 'inactive',
          label: 'Inactive',
        },
        {
          value: 'review',
          label: 'Submit back to user',
        },
        {
          value: 'qc_review',
          label: 'Submit back to QC',
        },
      ],
    },
  },
};

export default p;
